import { mergeContext } from '@aspectus/vue-utils';
import { tag, el } from '@aspectus/vue-dermis';
import { createBlockGenerator } from '@aspectus/bem';
import { truncateText } from '@md/strings';

const b = createBlockGenerator();

const [ReadMore, bl] = tag('read-more', {}, b);
const Visible = el('read-more-visible', bl, {}, 'visible');
const Toggler = el('read-more-toggler', bl, {}, 'toggler');

export default {
  name: 'read-more',
  props: {
    max: { default: Infinity, type: Number },
    deviation: { default: 15, type: Number },
    text: String,
    moreLabel: {},
    lessLabel: {},
    noLabel: Boolean,
  },
  inheritAttrs: false,
  data() {
    return {
      opened: false,
      // Запоминаем точку начала клика, чтобы отличать клик от выделения/drag
      mouseDownPoint: null,
      // Флаг, что мышь реально двигали, а не просто кликнули
      hasMouseDrag: false,
    };
  },
  computed: {
    texts() {
      const { max, text, deviation } = this;
      const fits = max === Infinity || max + deviation > text.length;

      if (fits && !text.includes('\n') || this.opened) {
        return [text, fits];
      }

      return [truncateText(text, max - deviation, max, max + deviation)[0] + '...', false];
    },
  },
  methods: {
    // Обычный toggle оставляем, но вызываем только когда это реально клик
    toggle() {
      this.opened = !this.opened;
    },

    // Запоминаем стартовую точку
    handleMouseDown(event) {
      this.mouseDownPoint = {
        x: event.clientX,
        y: event.clientY,
      };
      this.hasMouseDrag = false;
    },

    // Если мышь заметно сдвинулась — это уже drag/выделение
    handleMouseMove(event) {
      if (!this.mouseDownPoint) {
        return;
      }

      const dx = Math.abs(event.clientX - this.mouseDownPoint.x);
      const dy = Math.abs(event.clientY - this.mouseDownPoint.y);

      if (dx > 3 || dy > 3) {
        this.hasMouseDrag = true;
      }
    },

    // Клик должен работать только если не было выделения текста
    handleRootClick() {
      const selection = window.getSelection
        ? window.getSelection().toString().trim()
        : '';

      if (selection || this.hasMouseDrag) {
        this.mouseDownPoint = null;
        this.hasMouseDrag = false;
        return;
      }

      this.toggle();

      this.mouseDownPoint = null;
      this.hasMouseDrag = false;
    },
  },
  render(h) {
    const { toggle, noLabel, opened } = this;
    const [text, fits] = this.texts;
    const on = {
      click: this.handleRootClick,
      mousedown: this.handleMouseDown,
      mousemove: this.handleMouseMove,
    };

    return h(
      ReadMore,
      mergeContext({
        attrs: this.$attrs, on: Object.assign({}, this.$listeners),
        scopedSlots: this.$scopedSlots,
      }, {
        on: noLabel ? on : {},
        class: { 'is-opened': opened || fits },
        attrs: {
          variant: noLabel ? [this.$attrs['variant'], 'no-label'] : undefined,
        },
      }),
      [
        h(Visible, {}, [text]),
        fits ? null : ' ',
        noLabel || fits ? null : h(
          Toggler, { on }, [opened ? this.lessLabel : this.moreLabel]
        ),
      ]
    );
  },
}
